<!-- 
Up / down indicator for the levy calculator playground.

When a provider changes their levy parameters in the playground we show what impact their
changes would have on the different components of the levy by displaying a little up / down
indicator and a summary of the difference in values
-->
<template>
  <span>
    <template v-if="show && showOriginal && hasOriginal">
      <p v-if="up" :class="{caption: small}" class="mb-3">
        <v-icon :small="small" color="red">arrow_upward</v-icon>
        Up from {{ original | numericInput2 }}
      </p>
      <p v-else :class="{caption: small}" class="mb-3">
        <v-icon :small="small" color="green">arrow_downward</v-icon>
        Down from {{ original | numericInput2 }}
      </p>
    </template>
    <template v-if="show && !showOriginal">
      <p v-if="up" :class="{caption: small}" class="mb-3">
        <v-icon :small="small" color="red">arrow_upward</v-icon>
        Up {{ difference | currency }}
      </p>
      <p v-else :class="{caption: small}" class="mb-3">
        <v-icon :small="small" color="green">arrow_downward</v-icon>
        Down {{ -difference | currency }}
      </p>
    </template>
    <div v-if="!show" class="mb-3">&nbsp;</div>
  </span>
</template>

<script>
import filterMixins from "@/mixins/filter.mixins";

export default {
  mixins: [filterMixins],
  props: {
    field: {
      type: String,
      required: true
    },
    small: {
      type: Boolean,
      default: false
    },
    showOriginal: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    up() {
      return this.difference > 0;
    },
    state() {
      return this.$store.state.levyEstimator;
    },
    difference() {
      return this.state.playground.data.levyCollectionProvider.levyCalculation[this.field] - this.original;
    },
    original() {
      return this.state.estimator.data.levyCollectionProvider.levyCalculation[this.field];
    },
    hasOriginal() {
      return this.original != null;
    },
    show() {
      return this.state.playground.active && this.difference != 0;
    }
  }
};
</script>
